"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpectatorHome = void 0;
const vue_1 = require("vue");
const SpectatorOverview_1 = require("./overview/SpectatorOverview");
const OtherPlayer_1 = require("./OtherPlayer");
const Milestone_1 = require("./Milestone");
const Award_1 = require("./Award");
const Sidebar_1 = require("./Sidebar");
const Board_1 = require("./Board");
const Colony_1 = require("./Colony");
const ScoreChart_1 = require("../components/ScoreChart");
let ui_update_timeout_id;
exports.SpectatorHome = vue_1.default.component('spectator-home', {
    data: function () {
        return {};
    },
    props: {
        spectator: {
            type: Object,
        },
        settings: {
            type: Object,
        },
    },
    components: {
        'board': Board_1.Board,
        'colony': Colony_1.Colony,
        'spectator-overview': SpectatorOverview_1.SpectatorOverview,
        'other-player': OtherPlayer_1.OtherPlayer,
        'milestone': Milestone_1.Milestone,
        'award': Award_1.Award,
        'sidebar': Sidebar_1.Sidebar,
        'score-chart': ScoreChart_1.ScoreChart,
    },
    methods: {
        getFleetsCountRange: function (player) {
            const fleetsRange = [];
            for (let i = 0; i < player.fleetSize - player.tradesThisGeneration; i++) {
                fleetsRange.push(i);
            }
            return fleetsRange;
        },
        getSpectatorHomeClass(spectator) {
            if (spectator.turmoil)
                return 'spectator-container with-turmoil';
            return 'spectator-container';
        },
        forceRerender() {
            const root = this.$root;
            root.updateSpectator();
        },
    },
    mounted: function () {
        ui_update_timeout_id = window.setInterval(this.forceRerender, 5000);
    },
    beforeDestroy() {
        window.clearInterval(ui_update_timeout_id);
    },
    template: `<div id="spectator-home" :class="getSpectatorHomeClass(spectator)">
    <template>
      <sidebar v-trim-whitespace
        :acting_player="false"
        :player_color="spectator.color"
        :generation="spectator.generation"
        :coloniesCount="spectator.coloniesCount"
        :temperature = "spectator.temperature"
        :oxygen = "spectator.oxygenLevel"
        :oceans = "spectator.oceans"
        :venus = "spectator.venusScaleLevel"
        :turmoil = "spectator.turmoil"
        :moonData="spectator.moon"
        :gameOptions = "spectator.gameOptions"
        :playerNumber = "spectator.players.length"
        :silverCubeVariant = "spectator.silverCubeVariant"
        :temperatureSilverCubeBonusMC = "spectator.temperatureSilverCubeBonusMC"
        :oceansSilverCubeBonusMC = "spectator.oceansSilverCubeBonusMC"
        :oxygenSilverCubeBonusMC = "spectator.oxygenSilverCubeBonusMC"
        :venusSilverCubeBonusMC = "spectator.venusSilverCubeBonusMC"
        :lastSoloGeneration = "spectator.lastSoloGeneration">
          <div class="deck-size">{{ spectator.deckSize }}</div>
      </sidebar>
      <div class="spectator-column_info">
        <div class="row_log">
          <div class="player_home_block--log player_home_block--hide_log spectator_log_block">
            <log-panel :id="spectator.id" :players="spectator.players" :generation="spectator.generation" :lastSoloGeneration="spectator.lastSoloGeneration" :color="'black'"></log-panel>
          </div>
        </div>
        <div class="row_player_boards">
          <spectator-overview class="player_home_block--players" :player="spectator" v-trim-whitespace id="shortkey-playersoverview"/>
        </div>
      </div>
      <div class="column_main">
        <div class="other_player" v-if="spectator.players.length > 1">
          <div v-for="(otherPlayer, index) in spectator.players" :key="otherPlayer.id">
            <other-player v-if="otherPlayer.id !== spectator.id" :player="otherPlayer" :playerIndex="index"/>
          </div>
        </div>
        <div class="player_home_block">
          <a name="board" class="player_home_anchor"></a>
          <div style="margin-top:30px;">
            <board
            :spaces="spectator.spaces"
            :venusNextExtension="spectator.gameOptions.venusNextExtension"
            :venusScaleLevel="spectator.venusScaleLevel"
            :altVenusBoard="spectator.gameOptions.altVenusBoard"
            :automaSoloVariant="spectator.gameOptions.automaSoloVariant"
            :boardName ="spectator.gameOptions.boardName"
            :oceans_count="spectator.oceans"
            :oxygen_level="spectator.oxygenLevel"
            :temperature="spectator.temperature"
            :shouldNotify="false"
            :aresExtension="spectator.gameOptions.aresExtension"
            :aresData="spectator.aresData"
            :promoCardsOption="spectator.gameOptions.promoCardsOption"
            id="shortkey-board""></board>
          </div>

          <moonboard v-if="spectator.moon" :model="spectator.moon" :automaSoloVariant="spectator.gameOptions.automaSoloVariant"></moonboard>

          <div v-if="spectator.players.length > 1 || (spectator.players.length === 1 && spectator.gameOptions.automaSoloVariant)" class="player_home_block--milestones-and-awards">
            <milestone :milestones_list="spectator.milestones" :automaSoloVariant="spectator.gameOptions.automaSoloVariant" :corporations="spectator.players.map((p) => p.corporationCards).reduce((a, b) => a.concat(b))" :spectator="true" />
          </div>

          <div v-if="spectator.players.length > 1" class="player_home_block--milestones-and-awards">
            <award :awards_list="spectator.awards" :corporations="spectator.players.map((p) => p.corporationCards).reduce((a, b) => a.concat(b))" :spectator="true" />
          </div>

          <div v-if="spectator.colonies.length > 0" class="player_home_block" ref="colonies" id="shortkey-colonies">
            <a name="colonies" class="player_home_anchor"></a>
            <dynamic-title title="Colonies" :color="spectator.color"/>
            <div class="colonies-fleets-cont">
                <div class="colonies-player-fleets" v-for="colonyPlayer in spectator.players">
                    <div :class="'colonies-fleet colonies-fleet-'+ colonyPlayer.color" v-for="idx in getFleetsCountRange(colonyPlayer)"></div>
                </div>
            </div>
            <div class="player_home_colony_cont">
                <div class="player_home_colony" v-for="colony in spectator.colonies" :key="colony.name">
                    <colony :colony="colony"></colony>
                </div>
            </div>
          </div>

          <turmoil v-if="spectator.turmoil" :turmoil="spectator.turmoil"></turmoil>

          <div v-if="spectator.players.length > 1">
            <score-chart :players="spectator.players" :generation="spectator.generation" :animation="false"></score-chart>
          </div>
        </div>
      
      </div>
    </template>
  </div>`,
});
//# sourceMappingURL=SpectatorHome.js.map